import React from 'react'
import "./ViolationsPagination.css"
import {changePage} from "../../actions";
import { connect } from "react-redux";
import {store} from "../../store"
import {State} from "../../types";


type myProps  = {
    dispatch: Function
    getState: Function
};
type myState = {
    currPage : number,
};
export const ViolationsPagination = connect((state: State) => {
    return {
        violationsPagination: state.violationHistory.violationsPagination
    }
})
(class ViolationsPagination extends React.Component<myProps, myState> {
    constructor(props: any){
      super(props);
      this.state={
          currPage : 1,
      }
     
     store.subscribe(() => {
        // When state will be updated(in our case, when items will be fetched), 
        // we will update local component state and force component to rerender 
        // with new data.
  
        this.setState({
          currPage: store.getState().violationHistory.violationsPagination.currPage
        });
      });
    }
     render(){
         return (<div id = "pagination">
             <span  id = "prev" onClick = {()=>this.handlePrev()}>&lt;&lt; Prev    </span>
             <span  id = "next" onClick = {()=>this.handleNext()}>    Next &gt;&gt;</span>
         </div>)
     }
     handleNext(){
        const { dispatch } = this.props;
         dispatch(changePage('PAGE_CHANGED_TO_NEXT'));
     }
     handlePrev(){
        const { dispatch } = this.props;
        dispatch(changePage('PAGE_CHANGED_TO_PREV'));
     }
})




// WEBPACK FOOTER //
// ./src/components/ViolationsPagination/ViolationsPagination.tsx